module.exports = __webpack_public_path__ + "statics/img/cate3-4@2x.7c815574.png";